import React from 'react';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import IconoMovimiento from '../../UI/IconoMovimiento.js';
import IconoTitulo from '../../UI/IconoTitulo.js';
import { IconoOrganizador } from '../../UI/IconoOrganizador.js';
import { NombreEquipoTorneo } from '../../funciones/FuncionesEquipo.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaTorneoParticipantes.module.css';

const TablaTorneoParticipantes = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;
  const torneo = props.contexto?.torneo;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  // Verificar si hay alguna posición final cargada
  const hayPosiciones = lista && lista.some((item) => item.posicionFinal !== null);

  return (
    <React.Fragment>
      <tr className={`${styles.titulos}`} key="0">
        {hayPosiciones && <td className={`${styleCols.posicion}`}>Pos</td>}
        <td className={`${styleCols.equipo}`}>Equipo</td>
        <td className={`${styleCols.observaciones}`}>Observaciones</td>
        <td className={`${styles.editar}`}></td>
      </tr>
      {lista &&
        lista.map((item, index) => (
          <tr className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`} key={index}>
            {hayPosiciones && (
              <td className={`${styleCols.posicion}`}>{item.posicionFinal || ''}</td>
            )}
            <td className={`${styleCols.equipo}`}>
              {NombreEquipoTorneo(item.equipo || item, torneo)}
              {item && <IconoOrganizador objeto={item} />}
              {item && <IconoTitulo objeto={item} />}
              {item && <IconoMovimiento objeto={item} />}
            </td>
            <td className={`${styleCols.observaciones}`}>{item.observaciones || ''}</td>
            <ColumnaBotoneraItem
              idItem={item.id}
              onEditarItem={onEditarItem}
              onEliminarItem={onEliminarItem}
            />
          </tr>
        ))}
    </React.Fragment>
  );
};

export default TablaTorneoParticipantes;
